import React from 'react';

import { Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import PrivateRoute from './util/PrivateRoute';
import PublicRoute from './util/PublicRoute';

import Login from './routes/Login';
import Signup from './routes/Signup';
import Logout from './routes/Logout';
import ForgotPassword from './routes/passwds/ForgotPassword';
import ResetPassword from './routes/passwds/ResetPassword';
import CancelReset from './routes/passwds/CancelReset';
import ContactForm from './routes/contact/Contact';
import AuthenticatedApp from './AuthenticatedApp';
import NotFound from './components/NotFound';

import Invite from './routes/Invite';
import Marketplace from './routes/Marketplace';
function App() {
  console.log("in App() " + (new Date()).toLocaleTimeString());
  return (
    <>
      <Routes>
        <Route path="/" element={<PrivateRoute><AuthenticatedApp /></PrivateRoute>} exact={true} />
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/signup" element={<PublicRoute><Signup /></PublicRoute>} />
        <Route path="/logout" element={<PublicRoute><Logout /></PublicRoute>} />
        <Route path="/forgot" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
        <Route path="/reset/:resetToken" element={<PublicRoute><ResetPassword /></PublicRoute>} />
        <Route path="/cancelreset/:resetToken" element={<PublicRoute><CancelReset /></PublicRoute>} />
        <Route path="/invite/:inviteKey?" element={<PublicRoute><Invite /></PublicRoute>} />
        <Route path="/marketplace" element={<PublicRoute><Marketplace /></PublicRoute>} />
        <Route path="/contact" element={<PublicRoute><ContactForm /></PublicRoute>} />

        {/**/}<Route path="/account/*" element={<PrivateRoute><AuthenticatedApp /></PrivateRoute>} />
        <Route path="/account/:accountKey/*" element={<PrivateRoute><AuthenticatedApp /></PrivateRoute>} />

        <Route path="*" element={<PublicRoute><NotFound /></PublicRoute>} />
        {/*
              <PublicRoute path="/signup" component={Signup}  />
              <PublicRoute path="/logout" component={Logout}  />
              <PublicRoute path="/contact" component={ContactForm} exact={true} />
              <PublicRoute component={NotFound}  />
              */}
      </Routes>
    </>
  );
}

/*
import logo from './logo.svg';
import { Counter } from './features/counter/Counter';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <Counter />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <span>
          <span>Learn </span>
          <a
            className="App-link"
            href="https://reactjs.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            React
          </a>
          <span>, </span>
          <a
            className="App-link"
            href="https://redux.js.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Redux
          </a>
          <span>, </span>
          <a
            className="App-link"
            href="https://redux-toolkit.js.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Redux Toolkit
          </a>
          ,<span> and </span>
          <a
            className="App-link"
            href="https://react-redux.js.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            React Redux
          </a>
        </span>
      </header>
    </div>
  );
}
*/
export default App;
